class CmAbisalesNotice extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('dialog');
    const close = () => this.dialog.close();
    this.querySelector('.cm-abisales-close').addEventListener('click', close, options);
    this.querySelector('.cm-abisales-continue').addEventListener('click', close, options);
    this.querySelector('.cm-abisales-reopen').addEventListener('click', () => this.open(), options);
    this.dialog.addEventListener('close', () => document.documentElement.classList.remove('cm-abisales-open'), options);
    this.dialog.addEventListener('click', event => {
      const r = this.dialog.getBoundingClientRect();
      if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) close();
    }, options);
    if (!this.hasAttribute('data-design-mode')) this.open();
  }
  open() {
    if (this.dialog.open || typeof this.dialog.showModal !== 'function') return;
    if (document.querySelector('dialog[open]')) {
      clearTimeout(this.retry);
      this.retry = setTimeout(() => this.open(), 500);
      return;
    }
    this.dialog.showModal();
    document.documentElement.classList.add('cm-abisales-open');
    this.querySelector('.cm-abisales-close').focus();
  }
  disconnectedCallback() {
    this.controller?.abort(); clearTimeout(this.retry);
    document.documentElement.classList.remove('cm-abisales-open');
  }
}
if (!customElements.get('cm-abisales-notice')) customElements.define('cm-abisales-notice', CmAbisalesNotice);
